import { render, staticRenderFns } from "./spinner.pug?vue&type=template&id=06859f7c&lang=pug&"
import script from "./spinner.js?vue&type=script&lang=js&"
export * from "./spinner.js?vue&type=script&lang=js&"
import style0 from "./spinner.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06859f7c')) {
      api.createRecord('06859f7c', component.options)
    } else {
      api.reload('06859f7c', component.options)
    }
    module.hot.accept("./spinner.pug?vue&type=template&id=06859f7c&lang=pug&", function () {
      api.rerender('06859f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spinner/index.vue"
export default component.exports